export default "__VITE_ASSET__6033538d__"